module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceMarqueeRenderModule",
    "path": "front/piece-marquee-render.module"
  },
  "definition": {
    "name": "PieceMarqueeDefinition",
    "group": "Basic",
    "availablePlatforms": ["web"],
    "description": "Marquee",
    "fields": [
      {
        "name": "preloadImage",
        "label": "Precargar imagen en SSR",
        "type": "boolean",
        "defaultValue": false,
        "isExcluded": true
      },
      {
        "type": "groupCollapsable",
        "name": "opciones",
        "label": "Opciones",
        "flattenFields": true,
        "fields": [
          {
            "name": "speed",
            "label": "Velocidad - en preview -",
            "type": "options",

            "values": [
              {
                "value": "-0.25",
                "label": "Muy lento"
              },
              {
                "value": "-0.5",
                "label": "Lento"
              },
              {
                "value": "-0.75",
                "label": "Lento Medio"
              },
              {
                "value": "-1",
                "label": "Normal"
              },
              {
                "value": "-1.25",
                "label": "Rapido"
              },
              {
                "value": "-1.50",
                "label": "Rapido Medio"
              },
              {
                "value": "-1.75",
                "label": "Muy Rápido"
              }
            ],
            "mandatory": false,
            "defaultValue": '-1'
          },
          {
            "name": "backgroundColor",
            "label": "Background Color",
            "type": "color",
            "mandatory": false,
            "defaultValue": "#000"
          },
          {
            "name": "directionMode",
            "type": "boolean",
            "label": "Sentido Contrario",
            "mandatory": true,
            "defaultValue": false
          },
          {
            "label": "Padding",
            "name": "customPadding",
            "jsonPath": "styles.padding",
            "type": "linkedUnits"
          },
          {
            "label": "Separacion entre elementos - gap",
            "name": "gap",
            "type": "units",
            "mandatory": false,
            "defaultValue": "12px"
          },
          {
            "label": "Responsive Size",
            "name": "responsiveSize",
            "type": "responsiveSize",
            "defaultValue": ""
          },
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "bloque01",
        "label": "Bloque 1",
        "flattenFields": true,
        "fields": [
          {
            "type": "groupToggleable",
            "name": "texto01",
            "label": "Texto",
            "section": "styles",
            "jsonPath": "alignment",
            "flattenFields": true,
            "fields": [
              {
                "label": "Texto",
                "name": "field01",
                "type": "richText",
                "mandatory": false,
                "defaultValue": ""
              }
            ]
          },
          {
            "type": "groupToggleable",
            "name": "image01",
            "label": "Imágenes",
            "section": "styles",
            "jsonPath": "alignment",
            "fields": [
              {
                "label": "Landscape",
                "name": "imgLandscape",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
              {
                "label": "Portrait",
                "name": "imgPortrait",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
            ]
          }
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "bloque02",
        "label": "Bloque 2",
        "flattenFields": true,
        "fields": [
          {
            "type": "groupToggleable",
            "name": "texto02",
            "label": "Texto",
            "section": "styles",
            "jsonPath": "alignment",
            "flattenFields": true,
            "fields": [
              {
                "label": "Texto",
                "name": "field02",
                "type": "richText",
                "mandatory": false,
                "defaultValue": ""
              }
            ]
          },
          {
            "type": "groupToggleable",
            "name": "image02",
            "label": "Imágenes",
            "section": "styles",
            "jsonPath": "alignment",
            "fields": [
              {
                "label": "Landscape",
                "name": "imgLandscape",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
              {
                "label": "Portrait",
                "name": "imgPortrait",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
            ]
          }
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "bloque03",
        "label": "Bloque 3",
        "flattenFields": true,
        "fields": [
          {
            "type": "groupToggleable",
            "name": "texto03",
            "label": "Texto",
            "section": "styles",
            "jsonPath": "alignment",
            "flattenFields": true,
            "fields": [
              {
                "label": "Texto",
                "name": "field03",
                "type": "richText",
                "mandatory": false,
                "defaultValue": ""
              }
            ]
          },
          {
            "type": "groupToggleable",
            "name": "image03",
            "label": "Imágenes",
            "section": "styles",
            "jsonPath": "alignment",
            "fields": [
              {
                "label": "Landscape",
                "name": "imgLandscape",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
              {
                "label": "Portrait",
                "name": "imgPortrait",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
            ]
          }
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "bloque4",
        "label": "Bloque 4",
        "flattenFields": true,
        "fields": [
          {
            "type": "groupToggleable",
            "name": "texto04",
            "label": "Texto",
            "section": "styles",
            "jsonPath": "alignment",
            "flattenFields": true,
            "fields": [
              {
                "label": "Texto",
                "name": "field04",
                "type": "richText",
                "mandatory": false,
                "defaultValue": ""
              }
            ]
          },
          {
            "type": "groupToggleable",
            "name": "image04",
            "label": "Imágenes",
            "section": "styles",
            "jsonPath": "alignment",
            "fields": [
              {
                "label": "Landscape",
                "name": "imgLandscape",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
              {
                "label": "Portrait",
                "name": "imgPortrait",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
            ]
          }
        ]
      },
      {
        "type": "groupCollapsable",
        "name": "bloque5",
        "label": "Bloque 5",
        "flattenFields": true,
        "fields": [
          {
            "type": "groupToggleable",
            "name": "texto05",
            "label": "Texto",
            "section": "styles",
            "jsonPath": "alignment",
            "flattenFields": true,
            "fields": [
              {
                "label": "Texto",
                "name": "field05",
                "type": "richText",
                "mandatory": false,
                "defaultValue": ""
              }
            ]
          },
          {
            "type": "groupToggleable",
            "name": "image05",
            "label": "Imágenes",
            "section": "styles",
            "jsonPath": "alignment",
            "fields": [
              {
                "label": "Landscape",
                "name": "imgLandscape",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
              {
                "label": "Portrait",
                "name": "imgPortrait",
                "type": "image",
                "mandatory": false,
                "defaultValue": ""
              },
            ]
          }
        ]
      },
    ]
  }
};
